"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "DoubleClickZoom", {
  enumerable: true,
  get: function get() {
    return _DoubleClickZoom["default"];
  }
});
Object.defineProperty(exports, "DragAndDrop", {
  enumerable: true,
  get: function get() {
    return _DragAndDrop["default"];
  }
});
Object.defineProperty(exports, "DragBox", {
  enumerable: true,
  get: function get() {
    return _DragBox["default"];
  }
});
Object.defineProperty(exports, "DragPan", {
  enumerable: true,
  get: function get() {
    return _DragPan["default"];
  }
});
Object.defineProperty(exports, "DragRotate", {
  enumerable: true,
  get: function get() {
    return _DragRotate["default"];
  }
});
Object.defineProperty(exports, "DragRotateAndZoom", {
  enumerable: true,
  get: function get() {
    return _DragRotateAndZoom["default"];
  }
});
Object.defineProperty(exports, "DragZoom", {
  enumerable: true,
  get: function get() {
    return _DragZoom["default"];
  }
});
Object.defineProperty(exports, "Draw", {
  enumerable: true,
  get: function get() {
    return _Draw["default"];
  }
});
Object.defineProperty(exports, "Extent", {
  enumerable: true,
  get: function get() {
    return _Extent["default"];
  }
});
Object.defineProperty(exports, "Interaction", {
  enumerable: true,
  get: function get() {
    return _Interaction["default"];
  }
});
Object.defineProperty(exports, "KeyboardPan", {
  enumerable: true,
  get: function get() {
    return _KeyboardPan["default"];
  }
});
Object.defineProperty(exports, "KeyboardZoom", {
  enumerable: true,
  get: function get() {
    return _KeyboardZoom["default"];
  }
});
Object.defineProperty(exports, "Modify", {
  enumerable: true,
  get: function get() {
    return _Modify["default"];
  }
});
Object.defineProperty(exports, "MouseWheelZoom", {
  enumerable: true,
  get: function get() {
    return _MouseWheelZoom["default"];
  }
});
Object.defineProperty(exports, "PinchRotate", {
  enumerable: true,
  get: function get() {
    return _PinchRotate["default"];
  }
});
Object.defineProperty(exports, "PinchZoom", {
  enumerable: true,
  get: function get() {
    return _PinchZoom["default"];
  }
});
Object.defineProperty(exports, "Pointer", {
  enumerable: true,
  get: function get() {
    return _Pointer["default"];
  }
});
Object.defineProperty(exports, "Select", {
  enumerable: true,
  get: function get() {
    return _Select["default"];
  }
});
Object.defineProperty(exports, "Snap", {
  enumerable: true,
  get: function get() {
    return _Snap["default"];
  }
});
Object.defineProperty(exports, "Translate", {
  enumerable: true,
  get: function get() {
    return _Translate["default"];
  }
});
exports.defaults = defaults;

var _Collection = _interopRequireDefault(require("./Collection.js"));

var _DoubleClickZoom = _interopRequireDefault(require("./interaction/DoubleClickZoom.js"));

var _DragPan = _interopRequireDefault(require("./interaction/DragPan.js"));

var _DragRotate = _interopRequireDefault(require("./interaction/DragRotate.js"));

var _DragZoom = _interopRequireDefault(require("./interaction/DragZoom.js"));

var _KeyboardPan = _interopRequireDefault(require("./interaction/KeyboardPan.js"));

var _KeyboardZoom = _interopRequireDefault(require("./interaction/KeyboardZoom.js"));

var _Kinetic = _interopRequireDefault(require("./Kinetic.js"));

var _MouseWheelZoom = _interopRequireDefault(require("./interaction/MouseWheelZoom.js"));

var _PinchRotate = _interopRequireDefault(require("./interaction/PinchRotate.js"));

var _PinchZoom = _interopRequireDefault(require("./interaction/PinchZoom.js"));

var _DragAndDrop = _interopRequireDefault(require("./interaction/DragAndDrop.js"));

var _DragBox = _interopRequireDefault(require("./interaction/DragBox.js"));

var _DragRotateAndZoom = _interopRequireDefault(require("./interaction/DragRotateAndZoom.js"));

var _Draw = _interopRequireDefault(require("./interaction/Draw.js"));

var _Extent = _interopRequireDefault(require("./interaction/Extent.js"));

var _Interaction = _interopRequireDefault(require("./interaction/Interaction.js"));

var _Modify = _interopRequireDefault(require("./interaction/Modify.js"));

var _Pointer = _interopRequireDefault(require("./interaction/Pointer.js"));

var _Select = _interopRequireDefault(require("./interaction/Select.js"));

var _Snap = _interopRequireDefault(require("./interaction/Snap.js"));

var _Translate = _interopRequireDefault(require("./interaction/Translate.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * @module ol/interaction
 */

/**
 * @typedef {Object} DefaultsOptions
 * @property {boolean} [altShiftDragRotate=true] Whether Alt-Shift-drag rotate is
 * desired.
 * @property {boolean} [onFocusOnly=false] Interact only when the map has the
 * focus. This affects the `MouseWheelZoom` and `DragPan` interactions and is
 * useful when page scroll is desired for maps that do not have the browser's
 * focus.
 * @property {boolean} [doubleClickZoom=true] Whether double click zoom is
 * desired.
 * @property {boolean} [keyboard=true] Whether keyboard interaction is desired.
 * @property {boolean} [mouseWheelZoom=true] Whether mousewheel zoom is desired.
 * @property {boolean} [shiftDragZoom=true] Whether Shift-drag zoom is desired.
 * @property {boolean} [dragPan=true] Whether drag pan is desired.
 * @property {boolean} [pinchRotate=true] Whether pinch rotate is desired.
 * @property {boolean} [pinchZoom=true] Whether pinch zoom is desired.
 * @property {number} [zoomDelta] Zoom level delta when using keyboard or double click zoom.
 * @property {number} [zoomDuration] Duration of the zoom animation in
 * milliseconds.
 */

/**
 * Set of interactions included in maps by default. Specific interactions can be
 * excluded by setting the appropriate option to false in the constructor
 * options, but the order of the interactions is fixed.  If you want to specify
 * a different order for interactions, you will need to create your own
 * {@link module:ol/interaction/Interaction~Interaction} instances and insert
 * them into a {@link module:ol/Collection~Collection} in the order you want
 * before creating your {@link module:ol/Map~Map} instance. Changing the order can
 * be of interest if the event propagation needs to be stopped at a point.
 * The default set of interactions, in sequence, is:
 * * {@link module:ol/interaction/DragRotate~DragRotate}
 * * {@link module:ol/interaction/DoubleClickZoom~DoubleClickZoom}
 * * {@link module:ol/interaction/DragPan~DragPan}
 * * {@link module:ol/interaction/PinchRotate~PinchRotate}
 * * {@link module:ol/interaction/PinchZoom~PinchZoom}
 * * {@link module:ol/interaction/KeyboardPan~KeyboardPan}
 * * {@link module:ol/interaction/KeyboardZoom~KeyboardZoom}
 * * {@link module:ol/interaction/MouseWheelZoom~MouseWheelZoom}
 * * {@link module:ol/interaction/DragZoom~DragZoom}
 *
 * @param {DefaultsOptions} [opt_options] Defaults options.
 * @return {import("./Collection.js").default<import("./interaction/Interaction.js").default>}
 * A collection of interactions to be used with the {@link module:ol/Map~Map}
 * constructor's `interactions` option.
 * @api
 */
function defaults(opt_options) {
  var options = opt_options ? opt_options : {};
  var interactions = new _Collection["default"]();
  var kinetic = new _Kinetic["default"](-0.005, 0.05, 100);
  var altShiftDragRotate = options.altShiftDragRotate !== undefined ? options.altShiftDragRotate : true;

  if (altShiftDragRotate) {
    interactions.push(new _DragRotate["default"]());
  }

  var doubleClickZoom = options.doubleClickZoom !== undefined ? options.doubleClickZoom : true;

  if (doubleClickZoom) {
    interactions.push(new _DoubleClickZoom["default"]({
      delta: options.zoomDelta,
      duration: options.zoomDuration
    }));
  }

  var dragPan = options.dragPan !== undefined ? options.dragPan : true;

  if (dragPan) {
    interactions.push(new _DragPan["default"]({
      onFocusOnly: options.onFocusOnly,
      kinetic: kinetic
    }));
  }

  var pinchRotate = options.pinchRotate !== undefined ? options.pinchRotate : true;

  if (pinchRotate) {
    interactions.push(new _PinchRotate["default"]());
  }

  var pinchZoom = options.pinchZoom !== undefined ? options.pinchZoom : true;

  if (pinchZoom) {
    interactions.push(new _PinchZoom["default"]({
      duration: options.zoomDuration
    }));
  }

  var keyboard = options.keyboard !== undefined ? options.keyboard : true;

  if (keyboard) {
    interactions.push(new _KeyboardPan["default"]());
    interactions.push(new _KeyboardZoom["default"]({
      delta: options.zoomDelta,
      duration: options.zoomDuration
    }));
  }

  var mouseWheelZoom = options.mouseWheelZoom !== undefined ? options.mouseWheelZoom : true;

  if (mouseWheelZoom) {
    interactions.push(new _MouseWheelZoom["default"]({
      onFocusOnly: options.onFocusOnly,
      duration: options.zoomDuration
    }));
  }

  var shiftDragZoom = options.shiftDragZoom !== undefined ? options.shiftDragZoom : true;

  if (shiftDragZoom) {
    interactions.push(new _DragZoom["default"]({
      duration: options.zoomDuration
    }));
  }

  return interactions;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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